<template>
    <div class="container-fluid" id="footer">

        <div class="row">
            <div class="col-sm-1"></div>
            <div class="col-sm" id="pages">
                <span class="footer-heading">PAGES</span>
                <div class="footer-sub">
                    <a class="footer-text" href="/home">Home</a>
                    <a class="footer-text" href="/blog">Blog Posts</a>

                    <details class="footer-collapsible">
                        <summary class="footer-text footer-toggle">Packages</summary>
                        <div class="footer-nested">
                            <details class="footer-collapsible nested">
                                <summary class="footer-text footer-toggle">Link 1</summary>
                                <div class="footer-nested">
                                    <a class="footer-text" href="/packages/link1/sublink1">Sub Link 1</a>
                                    <a class="footer-text" href="/packages/link1/sublink2">Sub Link 2</a>
                                    <a class="footer-text" href="/packages/link1/sublink3">Sub Link 3</a>
                                    <a class="footer-text" href="/packages/link1/sublink4">Sub Link 4</a>
                                </div>
                            </details>
                            <a class="footer-text" href="/packages/link2">Link 2</a>
                            <a class="footer-text" href="/packages/link3">Link 3</a>
                        </div>
                    </details>

                    <details class="footer-collapsible">
                        <summary class="footer-text footer-toggle">About Us</summary>
                        <div class="footer-nested">
                            <a class="footer-text" href="/page/who-we-are">Who We Are</a>
                            <a class="footer-text" href="/page/what-we-do">What We Do</a>
                        </div>
                    </details>

                    <a class="footer-text" href="/itenary">Contact Us</a>
                </div>
            </div>
            <div class="col-sm" id="followus">
                <span class="footer-heading" id="follow-text">FOLLOW US</span>
                <div class="footer-sub">
                    <a class="footer-text" href="#"> <i class="fa fa-facebook" id="social-icons" style="padding:0px 12px 0px 0px"></i> FACEBOOK</a>
                    <a class="footer-text" href="#">  <i class="fa fa-instagram" id="social-icons"></i>  INSTAGRAM</a>
                    <a class="footer-text" href="#">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="x-social-icon" style="fill:white;vertical-align:middle;"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.74l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg> X
                    </a>
                </div>
            </div>
            <div class="col-sm" id="support">
                <span class="footer-heading">SUPPORT</span>
                <div class="footer-sub">
                    <a class="footer-text" href="#">Terms & Conditions</a>
                    <a class="footer-text" href="#">Privacy Policy</a>
                </div>
            </div>
            <div class="col-sm" id="sectors">
                <span class="footer-heading">SECTORS</span>
                <div class="footer-sub">
                    <router-link class="footer-text" to="/page/tourism">Tourism</router-link>
                    <details class="footer-collapsible nested">
                        <summary class="footer-text footer-toggle">Verticals</summary>
                        <div class="footer-nested">
                            <router-link class="footer-text" to="/page/eat">EAT</router-link>
                            <router-link class="footer-text" to="/page/sleep">SLEEP</router-link>
                            <router-link class="footer-text" to="/page/see">SEE</router-link>
                            <router-link class="footer-text" to="/page/do">DO</router-link>
                        </div>
                    </details>
                </div>
            </div>

            <div class="col-sm-1"></div>
        </div>
        <div class="row">
            <div class="col-sm-12 text-center">
                <p id="copyrights"> 2020  © Copyrights. Find It Smart Global Pty Ltd. All Rights Reserved </p>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'fis-footer',
  props: {
    name: String
  }
});
</script>

<style scoped>
.x-social-icon {
    width: 20px;
    height: 20px;
    padding: 0 10px 0 0;
    box-sizing: content-box;
}

@media (max-width: 1280px) { .x-social-icon { width: 14px; height: 14px; } }
@media (max-width: 1024px) { .x-social-icon { width: 13px; height: 13px; } }
@media (max-width: 768px)  { .x-social-icon { width: 10px; height: 10px; } }

.footer-collapsible {
    margin-top: 10%;
}

.footer-collapsible > summary {
    list-style: none;
    cursor: pointer;
    justify-content: flex-start;
    align-items: center;
    gap: 2px;
}

.footer-collapsible > summary::-webkit-details-marker {
    display: none;
}

.footer-collapsible > summary::after {
    content: '\f0d7';
    font-family: 'FontAwesome', 'Font Awesome 5 Free';
    font-weight: 900;
    font-size: 1em;
    margin-left: 2px;
    display: inline-block;
    vertical-align: middle;
}

.footer-collapsible[open] > summary::after {
    content: '\f0d8';
}

.footer-nested {
    padding-left: 12px;
}

.footer-collapsible.nested {
    margin-top: 8%;
}

.footer-nested .footer-text {
    margin-top: 8%;
}

</style>
